import {useEffect, useState} from 'react';

const getIsMobile = (): boolean => {
    // Mobile device break point: 768px
    return (window.innerWidth <= 768) as boolean;
}

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean>(getIsMobile());
    const onResize = () => setIsMobile(getIsMobile());

    const handleResize = () => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        }
    };

    useEffect(() => {
        handleResize();
    }, []);

    return isMobile;
};
